module.exports = __webpack_public_path__ + "static/media/Inspiron'22SlidingImage.d16ec065.png";